import {Api} from './config/request';

const getMessages = ({chatId, pageSize, fromTime}) =>
    Api.getRequest(
        `getMessages?chatId=${chatId}&pageSize=${pageSize}&fromTime=${fromTime}`,
        {resType: 'json', apiUrl: 'fresh'},
    );

const getAnalystStatus = (data) =>
    Api.getRequest(`getAnalystStatus?analystId=${data.analystId}`, {
        resType: 'json',
        apiUrl: 'fresh',
    });

const listOpenConversatons = () =>
    Api.getRequest('listOpenConversatons', {resType: 'json', apiUrl: 'fresh'});

const sendMessage = (data) => Api.postRequest(`sendMessage`, data);

const startConversation = (data) => Api.postRequest(`startConversation`, data);

const ChatAPI = {
    // getMessages,
    // sendMessage,
    // getAnalystStatus,
    // startConversation,
    // listOpenConversatons,
};

export default ChatAPI;
